import { createSelector } from "reselect"

import { MODULE_NAME } from "../helpers"

const selectEventMap = state => state[MODULE_NAME].eventMap
const selectResourceMap = state => state[MODULE_NAME].resourceMap
const selectRecordMap = state => state[MODULE_NAME].recordMap
const selectDataList = state => state[MODULE_NAME].dataList

export const selectCalendarMeta = state => state[MODULE_NAME].meta
export const selectCalendarData = createSelector(
  [
    createSelector(
      [
        createSelector(
          [selectDataList, selectRecordMap],
          (dataList, recordMap) => dataList.map(id => recordMap[id]),
        ),
        selectResourceMap,
      ],
      (records, resourceMap) =>
        records.map(record => ({
          ...record,
          resource: resourceMap[record.resource],
        })),
    ),
    selectEventMap,
  ],
  (records, eventsMap) =>
    records.map(record => ({
      ...record,
      items: record.items.map(id => eventsMap[id]),
    })),
)

export const selectEvent = (state, eventUuid) =>
  selectEventMap(state)[eventUuid]
